import { createSaga } from './saga-helpers';

import * as Api from '../api/google-api';

const watchGetCalendars = createSaga({
    type: 'GOOGLE_CALENDARS_FETCH',
    fn: Api.fetchCalendars,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        calendars: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchGetCalendar = createSaga({
    type: 'GOOGLE_CALENDAR_FETCH',
    fn: Api.fetchCalendar,
    args: action => [action.payload.calendarId],
    successPayload: calendar => ({ calendar })
});

const watchCreateEvent = createSaga({
    type: 'GOOGLE_EVENT_CREATE',
    fn: Api.createEvent,
    args: action => [action.payload.calendarId, action.payload.event],
    successPayload: ({ id: eventId }, action) => ({
        eventId,
        fragment: action.payload.event
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.event
    })
});

const watchGetEvents = createSaga({
    type: 'GOOGLE_EVENTS_FETCH',
    fn: Api.fetchEvents,
    args: action => [action.payload.calendarId, action.payload],
    successPayload: ({ items, hasMore, nextPageToken } = {}, action) => ({
        events: items,
        hasMore,
        nextPageToken,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchUpdateEvent = createSaga({
    type: 'GOOGLE_EVENT_UPDATE',
    fn: Api.updateEvent,
    args: action => [action.payload.calendarId, action.payload.eventId, action.payload.eventProps],
    successPayload: event => ({ event })
});

const watchRemoveEvent = createSaga({
    type: 'GOOGLE_EVENT_REMOVE',
    fn: Api.removeEvent,
    args: action => [action.payload.calendarId, action.payload.eventId]
});

const sagas = [watchGetCalendars, watchGetCalendar, watchCreateEvent, watchGetEvents, watchUpdateEvent, watchRemoveEvent];

export default sagas;
